// Imports
import { takeLatest, put, call } from 'redux-saga/effects';

// Types
import {
  CREATE_QUANTITYIMPORT_REQUEST,
  CREATE_QUANTITYIMPORT_SUCCESS,
  CREATE_QUANTITYIMPORT_FAILURE,
  LOOKUP_QUANTITYIMPORT_REQUEST,
  LOOKUP_QUANTITYIMPORT_SUCCESS,
  LOOKUP_QUANTITYIMPORT_FAILURE,
} from './types';

// Actions
import { createQuantityImport, lookupQuantityImport } from './actions';

/**
 * Function that handles applying a reviewed quantity import.
 *
 * @param {Object} deconstructed object
 * @returns {void}
 */
function* workerCreateQuantityImport({ token, payload }) {
  try {
    const response = yield call(createQuantityImport, {
      token,
      payload,
    });

    const { data } = response.data;

    yield put({
      type: CREATE_QUANTITYIMPORT_SUCCESS,
      data,
    });
  } catch (error) {
    const message = error.response && error.response.data ? error.response.data : null;
    yield put({ type: CREATE_QUANTITYIMPORT_FAILURE, ...{ error: message } });
  }
}

// Exports
export function* watcherCreateQuantityImport() {
  yield takeLatest(CREATE_QUANTITYIMPORT_REQUEST, workerCreateQuantityImport);
}

/**
 * Function that handles resolving product codes to their products.
 *
 * @param {Object} deconstructed object
 * @returns {void}
 */
function* workerLookupQuantityImport({ token, payload }) {
  try {
    const response = yield call(lookupQuantityImport, {
      token,
      payload,
    });

    const { data } = response.data;

    yield put({
      type: LOOKUP_QUANTITYIMPORT_SUCCESS,
      data,
    });
  } catch (error) {
    const message = error.response && error.response.data ? error.response.data : null;
    yield put({ type: LOOKUP_QUANTITYIMPORT_FAILURE, ...{ error: message } });
  }
}

// Exports
export function* watcherLookupQuantityImport() {
  yield takeLatest(LOOKUP_QUANTITYIMPORT_REQUEST, workerLookupQuantityImport);
}
